<script lang="ts">
export default {
  name: 'KkTutorial',
}
</script>

<script lang="ts" setup>
import { KkBox } from '../../base'

export interface Props {
  description1?: string
  description2?: string
  imgPath?: string
  tutorialDescription?: string
  availableService?: string
}

const props = withDefaults(defineProps<Props>(), {
  description1: '',
  description2: '',
  imgPath: '',
  tutorialDescription: '',
  availableService: '',
})
</script>

<template>
  <div class="p-box">
    <div class="p-box__body">
      <div>
        {{ props.description1 }}
      </div>
      <div>
        {{ props.description2 }}
      </div>
      <div class="p-box">
        <KkBox :title="$t('labels.tutorial.title')">
          <template #content class="tutorialBody">
            <div class="tutorialBody__topSection">
              <div class="tutorialBody__img">
                <img :src="props.imgPath" alt="">
              </div>
              <div class="tutorialBody__description">
                <p v-html="props.tutorialDescription" />
                <div v-if="availableService" class="availableService">
                  <p>{{ availableService }}</p>
                </div>
              </div>
            </div>
          </template>
        </KkBox>
      </div>
      <div class="buttonArea">
        <slot name="buttonArea" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
@import "../../../../../stylesheets/biz_spa/foundation/_mixin.scss";
.p-box {
  &__body {
    white-space: pre-line;
  }
}
.tutorialBody {
  display: flex;
  &__topSection {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px 30px;
    @include mq(sm) {
      flex-direction: row;
    }
  }
  &__img {
    max-width: 320px;
  }
  &__description {
    .availableService {
      margin-top: 20px;
      font-weight: bold;
    }
  }
}
.buttonArea {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
  // stylelint-disable selector-pseudo-class-no-unknown
  :deep(.c-button) {
    margin: 0;
    .button {
      width: 100%;
    }
  }
  // stylelint-enable
  @include mq(sm) {
    flex-direction: row;
  }
}
</style>
